import { IconContext } from 'react-icons';
import { MenuItem } from './SideMenuModels';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


// Menu Items
import * as MenuSettings from './SideMenuItems';

// Styles
import './SideMenuComponent.css';



export const SideMenuComponent = () => {

  const [t] = useTranslation();

  const Menu = MenuSettings.MenuItems.filter(item => process.env.REACT_APP_PREVIEW_FEATURES !== 'true' ? item.preview === false : item.preview === false || item.preview === true).map((item: MenuItem) => {
    const label = t(item.name);

    return (
      <IconContext.Provider key={item.key} value={{ className: 'menuItemIcon' }}>
        <NavLink
          key={item.key}
          to={item.target}
          className="menuItem"
          title={label}
          aria-label={item.ariaLabel || label}
        >
          <span className="menuItemIconSlot">{item.icon}</span>
          <span className="menuItemLabel">{label}</span>
          {item.badge && (
            /* El distintivo salio de estilos inline a clases: el color se
               elegia por item y terminaba en rellenos saturados sobre el azul
               de la barra. Ahora el tono lo define el significado. */
            <span className={`menuItemBadge menuItemBadge--${item.badgeTone ?? 'preview'}`}>
              {t(item.badge)}
            </span>
          )}
        </NavLink>
      </IconContext.Provider>
    );
  });

  return (
    /* El riel mantiene el ancho en el layout y el panel se expande por encima
       del contenido. Si el ancho lo cambiara el propio elemento en flujo, cada
       paso del mouse reacomodaria toda la pagina. */
    <div className="sideMenuRail">
      <div className="sideMenuStickyLeft sideMenuBackground">
        <nav className="sideMenuNav">{Menu}</nav>
      </div>
    </div>
  );
};
